import { render, staticRenderFns } from "./CorrectivesActions.vue?vue&type=template&id=1a6b7a84&scoped=true"
import script from "./CorrectivesActions.vue?vue&type=script&lang=js"
export * from "./CorrectivesActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b7a84",
  null
  
)

export default component.exports